export const PORTAL_CONTAINER_ID = 'portalContainer';
export const PORTAL_CONTAINER_SELECTOR = `#${PORTAL_CONTAINER_ID}`;
